import React, { useEffect } from "react";
import { claimService } from "../../../../api/services/claimService";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValue {
  setAllActionsOfLeave: (data: any) => void;
}
const DTOLeaveARModal = ({ setAllActionsOfLeave }: PropsValue) => {
  const storedLeaveActions = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredActions
  );

  useEffect(() => {
    if (storedLeaveActions) setAllActionsOfLeave(storedLeaveActions);
  }, []);

  return <></>;
};

export default DTOLeaveARModal;
